module.exports = __webpack_public_path__ + "static/media/non_image.3083fe0b.svg";